export function reviewFailureMessage(code: string | null) {
  switch (code) {
    case 'assessment_timeout':
      return 'The review exceeded its time limit. Your submitted files and explanation are saved.';
    case 'assessment_invalid_response':
    case 'model_output_truncated':
    case 'model_output_incomplete':
    case 'model_output_empty':
      return 'The reviewer could not produce complete, verifiable feedback. Your submitted files and explanation are saved.';
    case 'submission_too_large':
    case 'evaluation_input_too_large':
      return 'This submission exceeds the review size limit. Reduce the project to the relevant source files and submit again. Your previous submission is saved.';
    case 'submission_empty':
      return 'No eligible source files were captured. Save your source files in this activity before submitting again.';
    case 'submission_evidence_invalid':
      return 'The saved submission could not be verified. Contact support before replacing it.';
    case 'evaluation_version_unavailable':
      return 'The evaluator for this submission is unavailable. Your submitted files and explanation are saved; prepare a new submission to use the current evaluator.';
    case 'submission_limit_reached':
      return 'This submission was not reviewed because the workshop’s submission allowance was already used. The reference solution is shown with your last review.';
    case 'task_spec_invalid':
      return 'This workshop’s review configuration could not be loaded. Contact support; your submitted files and explanation are saved.';
    default:
      return 'The review could not finish. Your submitted files and explanation are saved.';
  }
}
